import { put, call, CallEffect, PutEffect } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { toastr } from 'react-redux-toastr';

import {
  userRegister,
  userLogin,
  generateLink,
  getCustomerFormData,
  getValidRegistrationNumber,
  getPreferedPartnerDataService,
  getValidApplicantEmail,
  getTenantAccountTypesService,
} from '../../../../api/endpoints/userRegisterService';
import {
  formSubmitSuccess,
  formSubmitFailed,
  userLoginSuccess,
  userLoginFailed,
  generateLinkSuccess,
  generateLinkFailed,
  getCustomerFormDataSuccess,
  getCustomerFormDataFailed,
  getBusinessRegistrationNumberSuccess,
  getBusinessRegistrationNumberFailed,
  getPreferedPartnerDataSuccess,
  getPreferdPartnerDataFailed,
  getValidApplicantEmailSuccess,
  getValidApplicantEmailFailed,
  getTenantAccountTypesSuccess,
  getTenantAccountTypesFailed,
} from '../reducer/homeDataSlice';

export function* handleFormSubmit(
  action: PayloadAction<string>
): Generator<CallEffect | PutEffect, void, unknown> {
  try {
    const response: any = yield call(userRegister, action.payload);
    const { status, data } = response;
    if (status !== 200) {
      throw new Error('Something went wrong');
    }
    toastr.clean(); // clean the previous toastr
    toastr.success('Success', `Thank you for submitting!`);
    yield put(formSubmitSuccess(data));
    setTimeout(() => {
      toastr.clean(); //  clean the toastr after 3 seconds
    }, 3000);
  } catch (error: any) {
    
    toastr.clean(); // clean the previous toastr
    toastr.error('Error', 'Something went wrong! Please try again later.');
    yield put(formSubmitFailed(error.message));
    setTimeout(() => {
      toastr.clean(); //  clean the toastr after 3 seconds
    }, 3000);
  }
}

export function* handleUserLogin(
  action: PayloadAction<string>
): Generator<CallEffect | PutEffect, void, unknown> {
  try {
    const response: any = yield call(userLogin, action.payload);
    const { status, data } = response;  
    if (status !== 200) {
      throw new Error('Something went wrong');
    }
    toastr.clean(); // clean the previous toastr
    toastr.success('Success', `User logged in successfully!`);
    yield put(userLoginSuccess(data));
    setTimeout(() => {
      toastr.clean(); //  clean the toastr after 3 seconds
    }, 3000);
  } catch (error: any) {
    toastr.clean(); // clean the previous toastr
    toastr.error(
      'Error',
      'Username or password is incorrect! Please try again.'
    );
    yield put(userLoginFailed(error.message));
    setTimeout(() => {
      toastr.clean(); //  clean the toastr after 3 seconds
    }, 3000);
  }
}

export function* handleGenerateLink(
  action: PayloadAction<string>
): Generator<CallEffect | PutEffect, void, unknown> {
  try {
    const response: any = yield call(generateLink, action.payload);
    const { status, data } = response.data;  
    
    if (status !== 200) { 
      throw new Error('Something went wrong');
    }
    toastr.clean(); // clean the previous toastr
    toastr.success('Success', `Link generated successfully!`);
    yield put(generateLinkSuccess(data));
    setTimeout(() => {
      toastr.clean(); //  clean the toastr after 3 seconds
    }, 3000);
  } catch (error: any) {
    toastr.clean(); // clean the previous toastr
    toastr.error('Error', 'Something went wrong! Please try again later.');
    yield put(generateLinkFailed(error.message));
    setTimeout(() => {
      toastr.clean(); //  clean the toastr after 3 seconds
    }, 3000);
  }
}

export function* handleGetCustomerFormData(
  action: PayloadAction<any>
): Generator<CallEffect | PutEffect, void, unknown> {
  const {customerUuid,setCustomerFormError}= action.payload;
  try {
    const response: any = yield call(getCustomerFormData, customerUuid);
    const {  data } = response.data;
    console.log({data});
    
    const { status } = response;
    if (status !== 200) {
      
      throw new Error('Something went wrong');
    }
    yield put(getCustomerFormDataSuccess(data));
  } catch (error: any) {
     setCustomerFormError(error.response?.data?.message );
    yield put(getCustomerFormDataFailed(error.message));
  }
}

export function* handleGetBusinessRegistrationNumber(
  action: PayloadAction<string>
): Generator<CallEffect | PutEffect, void, unknown> {
  try {
    const response: any = yield call(
      getValidRegistrationNumber,
      action.payload
    );
    const res = response?.data?.data?.available;
    yield put(getBusinessRegistrationNumberSuccess(!res));
  } catch (error: any) {
    yield put(getBusinessRegistrationNumberFailed(error.message));
  }
}

export function* handleGetPreferedPartnerData(
  action: PayloadAction<string>
): Generator<CallEffect | PutEffect, void, unknown> {
  try {
    const response: any = yield call(
      getPreferedPartnerDataService,
      action.payload
    );
    yield put(getPreferedPartnerDataSuccess(response?.data?.data));
  } catch (error: any) {
    yield put(getPreferdPartnerDataFailed(error.message));
  }
}

export function* handleGetValidApplicantEmail(
  action: PayloadAction<string>
): Generator<CallEffect | PutEffect, void, unknown> {
  try {
    const response: any = yield call(getValidApplicantEmail, action.payload);  
    yield put(
      getValidApplicantEmailSuccess(!response?.data?.data?.available)
    );
  } catch (error: any) {
    yield put(getValidApplicantEmailFailed(error.message));
  }
}

//get tenant account types dropdown
export function* handleGetTenantAccountTypes(): Generator {
  try {
    const response: any = yield call(getTenantAccountTypesService);
    yield put(getTenantAccountTypesSuccess(response?.data?.data));
  } catch (error: any) {
    yield put(getTenantAccountTypesFailed(error.message));
  }
}
